import { getTopDestinationsForTld } from '@/src/homepage/shared/utils/getTopDestinationsForTld';
import type { City, TLD } from '@/src/homepage/shared/types';
import deAtCities from './static/deAtCities.json';
import deChCities from './static/deChCities.json';
import deDeCities from './static/deDeCities.json';
import enAuCities from './static/enAuCities.json';
import enCaCities from './static/enCaCities.json';
import enDkCities from './static/enDkCities.json';
import enFiCities from './static/enFiCities.json';
import enGbCities from './static/enGbCities.json';
import enHkCities from './static/enHkCities.json';
import enIeCities from './static/enIeCities.json';
import enNzCities from './static/enNzCities.json';
import enSgCities from './static/enSgCities.json';
import enUsCities from './static/enUsCities.json';
import esArCities from './static/esArCities.json';
import esClCities from './static/esClCities.json';
import esCoCities from './static/esCoCities.json';
import esEsCities from './static/esEsCities.json';
import esMxCities from './static/esMxCities.json';
import esPeCities from './static/esPeCities.json';
import frBeCities from './static/frBeCities.json';
import frCaCities from './static/frCaCities.json';
import frChCities from './static/frChCities.json';
import frFrCities from './static/frFrCities.json';
import itItCities from './static/itItCities.json';
import nlBeCities from './static/nlBeCities.json';
import nlNlCities from './static/nlNlCities.json';
import ptBrCities from './static/ptBrCities.json';
import ptPtCities from './static/ptPtCities.json';
import svCities from './static/svCities.json';

export const POPULAR_CITIES_BY_LOCALE: Record<string, City[]> = {
    de_AT: deAtCities,
    de_CH: deChCities,
    de_DE: deDeCities,
    en_AU: enAuCities,
    en_CA: enCaCities,
    en_DK: enDkCities,
    en_FI: enFiCities,
    en_GB: enGbCities,
    en_HK: enHkCities,
    en_IE: enIeCities,
    en_NZ: enNzCities,
    en_SG: enSgCities,
    en_US: enUsCities,
    es_AR: esArCities,
    es_CL: esClCities,
    es_CO: esCoCities,
    es_ES: esEsCities,
    es_MX: esMxCities,
    es_PE: esPeCities,
    fr_BE: frBeCities,
    fr_CA: frCaCities,
    fr_CH: frChCities,
    fr_FR: frFrCities,
    it_IT: itItCities,
    nl_BE: nlBeCities,
    nl_NL: nlNlCities,
    pt_BR: ptBrCities,
    pt_PT: ptPtCities,
    sv: svCities,
};

export function getPopularCitiesForLocale(
    tld: TLD,
    locale = 'en_US',
    additionalExcludedSlugs: string[] = [],
) {
    const topDestinations = getTopDestinationsForTld(tld);
    // Exclude both the static top destinations and any extra slugs the caller
    // wants suppressed (e.g. the expanded /d/ city cards) so a city is never
    // shown as both a destination card and a popular-city pill.
    const excludedSlugs = new Set([
        ...topDestinations.map((dest) => dest.location_slug),
        ...additionalExcludedSlugs,
    ]);

    const popularCities = POPULAR_CITIES_BY_LOCALE[locale] || POPULAR_CITIES_BY_LOCALE['en_US'];

    return popularCities.filter((city) => !excludedSlugs.has(city.location_slug));
}
